var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBonaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68581 4.68625C1.25675 8.11531 -0.289939 12.7137 0.0446233 17.1978L17.1973 0.0451268C12.7132 -0.289498 8.11487 1.25719 4.68581 4.68625Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71313 28.2544C11.9994 33.5433 21.3969 33.2305 27.3138 27.3137C33.2306 21.3969 33.5434 11.9994 28.2545 5.71313L5.71313 28.2544Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9434 15.3555L17.3222 14.6086L15.9434 13.8617C15.6215 11.7704 13.9691 10.118 11.8778 9.79611L11.1308 8.41724L10.384 9.79605C8.2927 10.1179 6.64033 11.7704 6.31833 13.8617L4.93945 14.6086L6.31827 15.3555C6.6402 17.4468 8.29258 19.0992 10.3839 19.4211L11.1308 20.8L11.8777 19.4212C13.9691 19.0992 15.6215 17.4468 15.9434 15.3555ZM11.1309 17.3912C9.59408 17.3912 8.34827 16.1455 8.34827 14.6086C8.34827 13.0717 9.59402 11.826 11.1309 11.826C12.6678 11.826 13.9135 13.0717 13.9135 14.6086C13.9135 16.1455 12.6677 17.3912 11.1309 17.3912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1304 12.5217L11.7329 13.5652H12.9378L12.3353 14.6087L12.9378 15.6522H11.7329L11.1304 16.6956L10.528 15.6522H9.32312L9.92556 14.6087L9.32312 13.5652H10.528L11.1304 12.5217Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBonaire);
export default __webpack_public_path__ + "static/media/flag_bonaire.ee49419174df19ca1f1bbd44bf8c7e65.svg";
export { ForwardRef as ReactComponent };